import { motion, AnimatePresence } from "framer-motion";
import CyberButton from "../ui/CyberButton";

export function DepositPromptModal({
  show,
  onClose,
}: {
  show: boolean;
  onClose: () => void;
}) {
  if (!show) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center"
      >
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
          className="bg-[#0b0e18] cyber-frame rounded-2xl p-8 text-center w-[90%] max-w-md shadow-lg shadow-cyan-500/20"
        >
          <h2 className="text-white text-2xl font-bold mb-4">
            Insufficient Balance
          </h2>
          <p className="text-gray-400 mb-6">
            You need more funds to open this lootbox.
          </p>
          <div className="flex gap-4 justify-center">
            <CyberButton
              onClick={() => {
                window.parent.postMessage({ type: "OPEN_WALLET_MODAL" }, "*");
                onClose();
              }}
              className=" font-semibold  "
              variant="filled"
            >
              Deposit Now
            </CyberButton>
            <CyberButton
              onClick={onClose}
              className=" font-semibold"
              variant="outline"
            >
              Cancel
            </CyberButton>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
